var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMargheritaOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1C10.4658 1 11.6716 2.20543 11.6716 3.67162C11.6716 4.27433 11.6441 4.82937 11.5896 5.33628C12.0076 5.03471 12.4732 4.73357 12.9939 4.43887C14.2612 3.69911 15.9052 4.1373 16.645 5.41146C17.3779 6.68562 16.9397 8.32966 15.6655 9.06254C15.1449 9.36412 14.6517 9.61758 14.1791 9.82292C14.6517 10.0351 15.1449 10.2886 15.6655 10.5902C16.9397 11.323 17.3779 12.9671 16.645 14.2413C15.9052 15.5085 14.2612 15.9536 12.9939 15.2138C12.4732 14.9191 12.0076 14.6111 11.5896 14.3096C11.6446 14.8233 11.6716 15.3784 11.6716 15.9811C11.6716 17.4469 10.4662 18.6527 9 18.6527C7.52737 18.6527 6.32838 17.4473 6.32838 15.9811C6.32838 15.3784 6.35587 14.8233 6.41043 14.3096C5.99244 14.618 5.52676 14.9191 5.0061 15.2138C3.73194 15.9536 2.0879 15.5085 1.35502 14.2413C0.622136 12.9671 1.06032 11.323 2.33448 10.5902C2.85514 10.2886 3.34831 10.0351 3.81399 9.82292C3.34831 9.61758 2.85514 9.36412 2.33448 9.06254C1.06075 8.32966 0.622136 6.68562 1.35502 5.41146C2.0879 4.1373 3.73194 3.69911 5.0061 4.43199C5.52676 4.73357 5.99244 5.03471 6.41043 5.34315C6.35544 4.82937 6.32838 4.27433 6.32838 3.67162C6.32838 2.20543 7.52694 1 9 1Z",
    stroke: "#F48A1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99973 12.8163C10.6438 12.8163 11.9862 11.4738 11.9862 9.82291C11.9862 8.172 10.6438 6.8364 8.99973 6.8364C7.35569 6.8364 6.00635 8.17887 6.00635 9.82291C6.00635 11.467 7.34882 12.8163 8.99973 12.8163Z",
    stroke: "#F48A1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMargheritaOrange);
export default __webpack_public_path__ + "static/media/margheritaOrange.fd45d4db980bbec1ae196fd935515b7f.svg";
export { ForwardRef as ReactComponent };